import EsignComponent from './EsignContainer';

export default EsignComponent;
